<template>
    <div class="reg-goto-option position-relative">
        <div v-if="!showContinue">
           
            <h3 class="common-head">
            Select Registration Type
            </h3>
            <v-row>
            <v-col cols="12" md="6" sm="6">
                <div class="goto-options-wrap" @click="groupReg=false;selfReg=true;goForRegister();">
                <div class="option-img-hld">
                    <img src="../assets/Images/landing/self-reg.svg"/>
                </div>
                <h4>Self Registration</h4>
                </div>
            </v-col>
            <v-col cols="12" md="6" sm="6">
                <div class="goto-options-wrap" @click="selfReg=false;groupReg=true;showContinue = true">
                <div class="option-img-hld">
                    <img src="../assets/Images/landing/group-reg.svg"/>
                </div>
                <h4>Group Registration</h4>
                </div>
            </v-col>
            </v-row>
        </div>
        <div v-else  class="resistant-input-wrap" >
            <h3 class="common-head">
            <v-btn icon><v-icon color="#333" size="25px" @click="showContinue = false;selfReg=false;groupReg=false;">mdi-arrow-left</v-icon></v-btn> {{groupReg ? 'Group' : 'Self'}} Registration
            </h3>
            <div class="resistant-hld" v-if="groupReg">
            <p>Select number of registrants</p>
            <div class="resistant-count">
                <v-btn icon class="handle" @click="decrement()"><v-icon color="#333" size="25px">mdi-minus</v-icon></v-btn>
                <div class="text-box">{{count}}</div>
                <v-btn icon class="handle" @click="inecrement()"><v-icon color="#333" size="25px">mdi-plus</v-icon></v-btn>
            </div>
            </div>
            <div class="count-me mt-12">
            <a href="javascript:void(0);" @click="goForRegister()">Proceed</a>
            </div>
        </div>
    </div>
</template>
<script>
import { bus } from "@/main";
import APIs from "@/components/APIInit";
import axios from "axios";
import router from "@/router";
var self;
export default {
    data() {
    return {      
      count: 2,
      showContinue: false,
      groupReg: false,
      selfReg: false,
      eventId: null,
      clientId: null,
      DefaultRegistrationType: null
    };
  },
  mounted() {
    self = this;
    if (self.$store.state.publicEventCollection) {
      self.publicEventCollection = self.$store.state.publicEventCollection;      
    }
    self.clientId = self.getClientId();    
    self.eventId = self.publicEventCollection.replace('OA_UAT', '').replace(self.clientId, '').replace('_', '');
    self.getCheckoutFormJson();
  },
  methods: {
    inecrement(){
      if(this.count < 9){
        this.count++;
      }
      
    },
    decrement(){
       if(this.count > 2){
        this.count-- ;
      }
    },
    getCheckoutFormJson: function () {
      bus.$emit("toggleLoader", true);
      axios
      .get(`${APIs.googleSoragePath}${self.publicEventCollection}/Registration/CheckoutForms.JSON`)
      .then((response) => {
        response.data.RegistrationTypes.forEach((item) => {
          if (            
            item.RegistrationType.toLowerCase() == 'attendee'
          ) {
            self.DefaultRegistrationType = item;
            return;
          }
        });
          bus.$emit("toggleLoader", false);
      })
      .catch(() => {
          bus.$emit("toggleLoader", false);
      });
    },
    goForRegister() {
      bus.$emit("toggleLoader", true);
      let selectedRegistrationTypes = [this.DefaultRegistrationType];
      let regTypes = new Object();
      let formRegTypes = [];      
      for (let item of selectedRegistrationTypes) {
        let selectedQuantity = self.groupReg ? self.count : 1;
        for (let i = 1; i <= selectedQuantity; i++) {
          item["FormLabel"] = `${item.RegistrationType} Registrant ${i}`;
          formRegTypes.push({ ...item });
        }
        regTypes[item.RegistrationTypeId] = selectedQuantity;
      }
      let checkoutPice = 0;
      if (selectedRegistrationTypes.length) {
        let headers = {
          "content-type": "application/json",
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: self.clientId,
            eventId: self.eventId,
          },
          data: regTypes,
        };
        axios
          .post(APIs.InitRegisterAttendee, requestData, {
            headers: headers,
          })
          .then((response) => {
            console.log(response)
            bus.$emit("toggleLoader", false);
            if (response && response.data) {
              if (response.data.status == 0) {
                this.$parent.RegPageOptions = false;
                router.push({
                  name: "Reg3",
                  params: {
                    e: self.eventId,
                    bundleId: response.data.bundleId,
                    expiry: response.data.expiry,
                    regTypes: formRegTypes,
                    checkoutPice: Number(checkoutPice).toFixed(2),
                  },
                });
              } else {
                self.showSnackbar(response.data.msg, "error", "top");
              }
            } else {
              self.showSnackbar("Something went wrong!", "error", "top");
            }
          })
          .catch((error) => {
            bus.$emit("toggleLoader", false);
            self.showSnackbar("Something went wrong!", "error", "top");
            console.log(error);
          });
      } else {
        bus.$emit("toggleLoader", false);
        self.showSnackbar("Select Atleast One Ticket!", "error", "top");
      }
    },
  },
}
</script>